import firebase from 'firebase';
import config from '../config';
import log from 'loglevel';
import { firestore } from '../firebase';

const database = firebase.database();

export class Client {
  // eslint-disable-next-line class-methods-use-this
  async getAccount() {
    // Set client list
    log.debug('Loading Account: ', config);

    // Access account data
    log.debug(` - Getting: accounts/${config.account.id}`);

    const snapshot = await new Promise((resolve) => {
      database
        .ref(`accounts/${config.account.id}`)
        .once('value', resolve);
    });

    const accountConfig = snapshot.val();

    log.debug('GET ACCOUNT RESPONSE: ', accountConfig);

    return accountConfig;
  }

  async getAccountAdmin() {
    // Set client list
    console.log('Loading Account: ', config);

    // Access account data
    console.log(' - Getting: ' + `accounts/${config.account.id}`);
      
    const snapshot = await new Promise(resolve =>
      database
        .ref(`accounts/${config.account.id}`)
        .on('value', resolve)
    );
    // Parse account
    const accountConfig = snapshot.val();

    log.debug('GET ACCOUNT ADMIN RESPONSE: ', accountConfig);

    return accountConfig;
  }

  async getAccountPersonas(account, activeClientId) {
    // Query firestore
    const querySnapshot = await new Promise(resolve => 
      firestore
        .collection('personas_v0.9')
        .where('account', '==', account.config.accountId)
        .where('client', '==', activeClientId)
        .onSnapshot(resolve)
    );

    const personas = [];
    querySnapshot.forEach((doc) => {
      personas.push(doc.data().data);
    });

    log.debug('GET ACCOUNT PERSONAS RESPONSE: ', personas);
    
    return personas;
  }
}

export default Client;
